import { Category } from "@/types";
import { atom } from "jotai";

const indoorCategoriesAtom = atom<Category[]>([]);

export default indoorCategoriesAtom;
